(function (angular) {
    'use strict';

    angular.module('dashboard')

        /**
         *
         */
        .factory('dashboardMessageDataService',
            ['$http', '$q', 'portalConfig', 'apiSpacePicker', 'channelsProvider',
                function ($http, $q, portalConfig, apiSpacePicker, channelsProvider) {

                    var urlBase = portalConfig.urlBase;

                    function aggregateChannels(info) {
                        var count = 0;
                        if (info) {

                            for (var channelName in info) {
                                count += info[channelName];
                            }
                        }
                        return count;
                    }

                    function createLineData(data) {
                        var _data = {
                            datasets: [{
                                data: [],
                                backgroundColor: "#39A60C",
                                borderColor: "#39A60C",
                                fill: false,
                            }],
                        }

                        data.forEach(function (item) {
                            _data.datasets[0].data.push({ y: aggregateChannels(item.success), x: moment(item.date) });
                        });

                        return _data;
                    }

                    function createBarData(data) {

                        var _labelColors = {
                            sms: "#12f990",
                            fbMessenger: "#01b8ff",
                            twitterDm: "#1da1f2",
                            appMessaging: "#865cd6",
                            email: "#fabb49",
                            whatsApp: "#25D366",
                            rcs: "#333333"
                        }

                        var _labels = {
                            sms: "SMS",
                            fbMessenger: "Messenger",
                            twitterDm: "Twitter",
                            appMessaging: "App Messaging",
                            email: "Email",
                            whatsApp: "WhatsApp",
                            rcs: "RCS"
                        }

                        var _channelSpread = {
                            "sms": 0,
                            "fbMessenger": 0,
                            "twitterDm": 0,
                            "appMessaging": 0,
                            "email": 0,
                            "whatsApp": 0,
                            "rcs": 0
                        };

                        //removing channels that aren't allowed to be displayed
                        for (var channelId in channelsProvider) {
                            if (!channelsProvider[channelId].allowed) {
                                delete _labelColors[channelId];
                                delete _labels[channelId];
                                delete _channelSpread[channelId];
                            }
                        }

                        var _data = {
                            labels: [],
                            colors: [],
                            datasets: [{ data: [], backgroundColor: [] }],
                        }

                        data.forEach(function (item) {
                            for (var channelName in item.success) {
                                _channelSpread[channelName] += item.success[channelName];
                            }
                        });

                        for (var channelName in _channelSpread) {
                            _data.labels.push(_labels[channelName]);
                            _data.datasets[0].data.push(_channelSpread[channelName]);
                            _data.datasets[0].backgroundColor.push(_labelColors[channelName]);
                        }

                        return _data;
                    }

                    function processData(data) {
                        return {
                            line: createLineData(data),
                            bar: createBarData(data),
                        }
                    }

                    var fac = {

                        getMessageData: function () {

                            var pickedApiSpaceId = apiSpacePicker.getPickedApiSpace().id;

                            var from = moment().startOf('day').toDate();
                            var to = moment().endOf('day').toDate();

                            var url = urlBase + "/apispaces/" + pickedApiSpaceId + "/analytics/messages?from=" +
                                from.toISOString() +
                                "&to=" + to.toISOString() +
                                "&direction=outbound&by=hour";

                            return $http.get(url)
                                .then(getMessageDataComplete)
                                .catch(getMessageDataFailed);

                            function getMessageDataComplete(response) {
                                return processData(response.data);
                            }

                            function getMessageDataFailed(error) {
                                console.error(JSON.stringify(error));
                                return $q.reject(error);
                            }
                        }
                    };

                    return fac;
                }]);

})(window.angular);
